import React, { useState, useEffect } from 'react';
import './PayrollTable.css';

const API = '/api/payroll';
const todayISO = () => new Date().toISOString().slice(0, 10);
const fmtDate = d => d ? new Date(d).toLocaleDateString('ru') : '—';
const fmtRub = v => (v || v === 0) ? parseFloat(v).toLocaleString('ru') + ' ₽' : '—';

export default function Hotels() {
  const [hotels, setHotels]   = useState([]);
  const [edit, setEdit]       = useState({});     // id -> { rate, date }
  const [saving, setSaving]   = useState({});
  const [open, setOpen]       = useState({});     // id -> bool
  const [history, setHistory] = useState({});     // id -> [{valid_from, rate}]
  const [error, setError]     = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    const data = await fetch(`${API}/hotel-rates`).then(r => r.json());
    setHotels(Array.isArray(data) ? data : []);
  }

  async function loadHistory(id) {
    const data = await fetch(`${API}/hotel-rates/${id}/history`).then(r => r.json());
    setHistory(h => ({ ...h, [id]: Array.isArray(data) ? data : [] }));
  }

  async function toggleHistory(id) {
    const next = !open[id];
    setOpen(o => ({ ...o, [id]: next }));
    if (next) await loadHistory(id);
  }

  function startEdit(h) {
    setEdit(e => ({ ...e, [h.id]: { rate: h.rate || '', date: todayISO() } }));
  }

  function cancelEdit(id) {
    setEdit(e => { const n = { ...e }; delete n[id]; return n; });
  }

  async function save(id) {
    const e = edit[id];
    const rate = parseFloat(e.rate);
    if (isNaN(rate) || rate < 0 || !e.date) return;
    setSaving(s => ({ ...s, [id]: true }));
    setError('');
    const res = await fetch(`${API}/hotel-rates?hotel_id=${id}&valid_from=${e.date}&rate=${rate}`, { method: 'POST' });
    const data = await res.json().catch(() => ({}));
    setSaving(s => ({ ...s, [id]: false }));
    if (!res.ok) {
      setError(`${hotels.find(h => h.id === id)?.name}: ${data.detail || 'ошибка сохранения'}`);
      return;
    }
    cancelEdit(id);
    await load();
    if (open[id]) await loadHistory(id);
  }

  const withRate = hotels.filter(h => h.rate > 0).length;

  return (
    <div className="pt-page">
      <div className="pt-header">
        <h2>Отели — ставки администраторов</h2>
      </div>

      <div className="stat-cards" style={{ marginBottom: 16 }}>
        <div className="stat-card"><div className="label">Всего отелей</div><div className="value" style={{ fontSize: 22 }}>{hotels.length}</div></div>
        <div className="stat-card"><div className="label">Со ставкой</div><div className="value green" style={{ fontSize: 22 }}>{withRate}</div></div>
        <div className="stat-card"><div className="label">Без ставки</div><div className="value red" style={{ fontSize: 22 }}>{hotels.length - withRate}</div></div>
      </div>

      <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 12 }}>
        Ставка применяется к расчётным периодам, которые начинаются в дату «действует с» или позже. Прошлые периоды остаются по старой ставке.
      </div>

      {error && (
        <div style={{ background: '#fef2f2', color: '#b91c1c', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 14px', marginBottom: 12, fontSize: 14 }}>
          {error}
        </div>
      )}

      <table className="pt-table">
        <thead>
          <tr>
            <th>Отель</th>
            <th>Ставка за сутки</th>
            <th>Действует с</th>
            <th>День / ночь</th>
            <th>Изменить</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {hotels.map(h => {
            const e = edit[h.id];
            return (
              <React.Fragment key={h.id}>
                <tr>
                  <td style={{ fontWeight: 500, color: '#111827' }}>
                    {h.name}
                    {h.next_rate != null && (
                      <div style={{ fontSize: 12, color: '#d97706', fontWeight: 400 }}>
                        с {fmtDate(h.next_from)}: {fmtRub(h.next_rate)}
                      </div>
                    )}
                  </td>
                  <td style={{ color: h.rate > 0 ? '#111827' : '#9ca3af' }}>{h.rate > 0 ? fmtRub(h.rate) : 'не задана'}</td>
                  <td style={{ color: '#6b7280', fontSize: 13 }}>{fmtDate(h.valid_from)}</td>
                  <td style={{ color: '#6b7280', fontSize: 13 }}>{h.rate > 0 ? fmtRub(h.rate / 2) : '—'}</td>
                  <td>
                    {!e ? (
                      <button className="btn-secondary" style={{ padding: '6px 14px', fontSize: 13 }} onClick={() => startEdit(h)}>Новая ставка</button>
                    ) : (
                      <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                        <input type="number" min="0" value={e.rate} placeholder="ставка" autoFocus
                          onChange={ev => setEdit(x => ({ ...x, [h.id]: { ...x[h.id], rate: ev.target.value } }))}
                          style={{ width: 100, padding: '6px 10px', border: '1px solid #3b82f6', borderRadius: 8, fontSize: 14 }} />
                        <span style={{ fontSize: 12, color: '#6b7280' }}>с</span>
                        <input type="date" value={e.date}
                          onChange={ev => setEdit(x => ({ ...x, [h.id]: { ...x[h.id], date: ev.target.value } }))}
                          style={{ padding: '5px 8px', border: '1px solid #3b82f6', borderRadius: 8, fontSize: 14 }} />
                        <button className="btn-primary" style={{ padding: '6px 14px', fontSize: 13 }}
                          onClick={() => save(h.id)} disabled={saving[h.id]}>
                          {saving[h.id] ? '...' : 'Сохранить'}
                        </button>
                        <button className="btn-secondary" style={{ padding: '6px 10px', fontSize: 13 }} onClick={() => cancelEdit(h.id)}>✕</button>
                      </div>
                    )}
                  </td>
                  <td>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: 13 }}
                      onClick={() => toggleHistory(h.id)}>
                      {open[h.id] ? '▲ история' : '▼ история'}
                    </button>
                  </td>
                </tr>
                {open[h.id] && (
                  <tr>
                    <td colSpan={6} style={{ background: '#fafafa' }}>
                      {(history[h.id] || []).length === 0 ? (
                        <span style={{ color: '#9ca3af', fontSize: 13 }}>Ставок ещё не было</span>
                      ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 13 }}>
                          {history[h.id].map((r, i) => (
                            <div key={i} style={{ display: 'flex', gap: 16 }}>
                              <span style={{ width: 110, color: '#6b7280' }}>{r.valid_from === '2000-01-01' ? 'до этого' : 'с ' + fmtDate(r.valid_from)}</span>
                              <strong>{fmtRub(r.rate)}</strong>
                            </div>
                          ))}
                        </div>
                      )}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
